import { useState } from "react";
import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { PolicyControl } from "../PolicySections.types";
import PolicyControlsPicker from "./PolicyControlsPicker";

export interface PolicyControlsDialogProps {
    title: string | null;
    availableControls: Array<PolicyControl>;
    selectedControlIds: Array<string>;
    onSave: (controlIds: Array<string>) => void;
    onClose: () => void;
}

function PolicyControlsDialog(props: PolicyControlsDialogProps) {
    const { translateString } = useTranslation();
    const [selectedIds, setSelectedIds] = useState<Array<string>>(props.selectedControlIds);

    return (
        <DotLegalDialog
            open
            header={translateString("linkControlsDialogTitle", { name: props.title ?? "" })}
            buttonOkText={translateString("save")}
            secondaryButtonText={translateString("cancel")}
            onOkClick={() => props.onSave(selectedIds)}
            onSecondaryButtonClick={props.onClose}
            onDialogClose={props.onClose}
            size="lg"
            fullHeight
        >
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
                <Box sx={{ alignSelf: "center" }}>
                    <DotLegalHeader fontWeight={400} headerStyle={"small"}>
                        {translateString("linkControlsDialogDescription")}
                    </DotLegalHeader>
                </Box>
                <PolicyControlsPicker availableControls={props.availableControls} selectedIds={selectedIds} onSelectedIdsChange={setSelectedIds} />
            </Box>
        </DotLegalDialog>
    );
}

export default PolicyControlsDialog;
